export const insuranceProviders = {
  "MA": [
    "United Healthcare",
    "Unicare / Wellpoint",
    "Aetna",
    "Blue Cross Blue Shield",
    "Harvard Pilgrim",
    "Cigna"
  ],
  "CT": [
    "Cigna",
    "Aetna",
    "Anthem Blue Cross Blue Shield",
    "United Healthcare",
    "Emblem Health"
  ],
  "NH": [
    "Aetna",
    "Anthem",
    "Cigna",
    "United Healthcare",
    "Harvard Pilgrim"
  ],
  "FL": [
    "Aetna",
    "United Healthcare",
    "Ambetter Sunshine Health",
    "Blue Cross Blue Shield PPO",
    "Oscar"
  ],
  "WA": [
    "Aetna",
    "United Healthcare",
    "Regence Blue Cross Blue Shield",
    "Blue Cross Blue Shield PPO"
  ],
  "CA": [
    "Blue Cross Blue Shield PPO"
  ]
};

export const getInsuranceProvidersForState = (stateName) => {
  // Map full state names to abbreviations
  const stateMap = {
    "Massachusetts": "MA",
    "California": "CA",
    "Washington": "WA",
    "New Hampshire": "NH",
    "Connecticut": "CT",
    "Florida": "FL"
  };
  
  const stateAbbr = stateMap[stateName];
  return stateAbbr ? insuranceProviders[stateAbbr] : [];
};
